import React from 'react';
import { GoFormzLogoIconSmallBlue } from '../../icons/icons';
import './GlobalBanner.scss';

export type GlobalBannerProps = {
  message: React.ReactNode;
  handleDismiss?: () => void;
  icon?: React.ReactNode;
};

export default function GlobalBanner(props: GlobalBannerProps) {
  return (
    <div className="notification-banner" data-testid="global-notification-banner">
      <div className="banner-logo-wrapper">{props.icon ?? <GoFormzLogoIconSmallBlue />}</div>
      <span>{props.message}</span>
      {props.handleDismiss && (
        <div className="dismiss-button" onClick={props.handleDismiss}>
          X
        </div>
      )}
    </div>
  );
}
